import { gql } from "@apollo/client";
import {
  PaginatedListMetaNoNestingFragment,
  StaffNoNestingFragment,
} from "@towersystems/roam-common/lib/generated-graphql-fragment";
import { Staff as StaffEntity } from "@towersystems/roam-common/lib/generated-types";
import { client } from "../../../apollo";
import StaffModel from "../../data/model/Staff";
import { listOptions, listVariables } from "../constants";
import { EntityResourceDefinition } from "../entity-resource-definition";
import { pageQuery } from "../page-query";

const staffsQuery = gql`
 ${StaffNoNestingFragment}
 ${PaginatedListMetaNoNestingFragment}
query GetStaffs(${listVariables}) {
    staffs(${listOptions}) {
        items {
          ...StaffNoNesting
        }
        meta {
          ...PaginatedListMetaNoNesting
        }
    }
    
}
`;

export const staffDefinition = new EntityResourceDefinition<
  StaffEntity,
  StaffModel
>({
  entity: "staffs",
  query: staffsQuery,
  prepareEntity: (newEntity, fetchedEntity) => {
    newEntity.fullName = fetchedEntity.fullName;
    newEntity.initials = fetchedEntity.initials;
    newEntity.enabled = fetchedEntity.enabled;
    newEntity.username = fetchedEntity.username ?? "";
    newEntity.userId = fetchedEntity.userId ?? "";
    newEntity.terminalIds = fetchedEntity.terminalIds;
    newEntity.emailAddress = fetchedEntity.emailAddress ?? "";
    newEntity.hasUserAccount = fetchedEntity.hasUserAccount ?? false;
  },
  fetchEntities: (options) => {
    return pageQuery(client, "staffs", staffsQuery, options);
  },
});
